export const Scoring = {
    MIN_POINTS: 0.5,
    MAX_POINTS: 9.5,
    POINTS_STEP: 0.5,
} as const;
